.sheet {
  display: none;
}

.words {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px 24px;
  margin: 24px 0;
  padding: 0;
  list-style: none;
  font-family: ui-monospace, 'SFMono-Regular', Menlo, Consolas, monospace;
  font-size: 18pt;
}

.words li {
  display: flex;
  gap: 10px;
  padding: 8px 12px;
  border: 1px solid var(--black);
}

.number {
  min-width: 1.6em;
  color: var(--text-muted);
}

.meta {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 4px 16px;
  margin: 0 0 24px;
  font-size: 12pt;
}

.meta dt {
  color: var(--text-muted);
}

.meta dd {
  margin: 0;
  font-family: ui-monospace, 'SFMono-Regular', Menlo, Consolas, monospace;
}

.warning {
  padding: 12px 16px;
  border: 2px solid var(--black);
  font-size: 12pt;
  font-weight: 600;
}

@media print {
  :global(body.recovery-printing) > :global(#root) {
    display: none;
  }

  :global(body.recovery-printing) .sheet {
    display: block;
    color: var(--black);
    background: var(--white);
  }
}
